import React from 'react';
import DropDownSelect from "./DropDown";
import SearchSuggestions from "./SearchSuggestions";
import SearchIcon from './images/searchIconDark.svg';
import LoadingSvg from './images/loading.svg';
import './css/Filters.css';
import { AFFILIATE_API_PATH } from "./actions/constant";

class CollectionFilters extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            selectedCollectionId: this.props.currentCollectionId,
            selectCollection: this.props.currentCollection,
            searchResult: {
                status: false,
                activities: []
            },
            searchLoading: false
        }
        this.itemSelected = this.itemSelected.bind(this);
    }
    itemSelected(collectionId, collectionName) {
        this.setState({
            selectedCollectionId: collectionId,
            selectCollection: collectionName
        });
        this.props.filterActivities(collectionId, collectionName);
    }

    handleInputChange = (event) => {
        var value = event.target.value;
        var localSearchUrl = AFFILIATE_API_PATH+"searchLocally.php?collectionId="+this.props.currentCollectionId+"&q="+value;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', localSearchUrl);
        xhr.send();
        var that = this;
        xhr.onreadystatechange = function() {
            if(this.readyState === 4 && this.status === 200){
            var res = JSON.parse(this.responseText);
            var activities = res.activities;
            that.setState({
                searchResult: {
                    status: res.status,
                    activities: activities,
                },
                searchLoading: false
            });
            }
        }

        this.setState({
            searchLoading: true
        });
    }
    render(){
        return (
            <div className="row" style={{display:'flex',width:'100%',alignItems:'center'}}>
                <div className="select-collection-dropdown col-xl-5 col-sm-12">
                    <DropDownSelect 
                        menuItem={this.props.collectionList} 
                        selectedItem={ this.props.currentCollection }
                        selectedItemId={ this.props.currentCollectionId }
                        itemSelected={ this.itemSelected }
                        makeLinks = {true}
                        
                        affiliateUsername={this.props.affiliateUsername}
                        className="collection-filter-dropdown"
                        collectionUrl = {this.props.collectionUrl}
                    />
                </div>
                <div className="search-inside-collection col-xl-7 col-sm-12" style={{display:'flex',height:'100%',width:'65%',alignItems:'center',position:'relative'}}>
                    <div className="searchIcon" style={{marginRight:'0.5rem',marginLeft:'0.5rem'}}> 
                        <img src={(this.state.searchLoading)?LoadingSvg:SearchIcon} style={{display:'block',width:'1.2rem'}} alt=""/>
                    </div>
                    <div className="search-input" style={{height:'100%',width:'100%'}}>
                        <input type='text' placeholder='Search in the collection' aria-label="Search Activities within the selected collection" onKeyUp={this.handleInputChange}/>
                    </div>

                    <div>
                        <SearchSuggestions result={this.state.searchResult.activities} loading={this.state.searchLoading}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default CollectionFilters;


// WEBPACK FOOTER //
// ./src/CollectionFilters.jsx